import React, {Component} from 'react';
import PropTypes from 'prop-types';


export default class DefaultLanguageSelect extends Component {

	static propTypes = {
		languages: PropTypes.array,
		setDefaultLanguage: PropTypes.func,

	};

	render() {

		const {languages, setDefaultLanguage} = this.props;

		return (
			<div className="form-group has-label">
				<label>Default Language for new Labels</label>
				<select defaultValue="Default Language *" className="form-control"
						onChange={(event) => setDefaultLanguage(event.target.value)}>
					<option disabled hidden>Default Language *</option>
					{languages.map(function (language) {
						return (<option key={language.identifier}>{language.identifier}</option>)
					})}
				</select>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/DefaultLanguageSelect.js